import Link from 'next/link';

function ButtonLink(props) {
  const { href = '#', target = '_blank' || '_parent', rel = 'noopener noreferrer', referrerPolicy = 'no-referrer', children } = props;
  return (
    <Link
      {...props}
      href={href}
      target={target}
      rel={rel}
      referrerPolicy={referrerPolicy}
      className={`py-2.5 px-5 bg-amber-300 block uppercase hover:bg-white text-center text-white hover:text-gold transition-colors duration-300 border border-transparent hover:border-gold rounded-xl bg-gold hover:bg-none bg-cover bg-center bg-no-repeat font-schibsted ${props.className}`}
    >
      {children}
    </Link>
  );
}

export default ButtonLink;
